import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { GerenciarOcorrenciasService } from '@services/gerenciar-ocorrencias.service';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';

@Component({
    selector: 'app-alert-arquivos-anexados',
    templateUrl: './alert-arquivos-anexados.component.html',
    styleUrls: ['./alert-arquivos-anexados.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatGridList, MatGridTile]
})
export class AlertArquivosAnexadosComponent {

  @Input() arquivosAnexados: string[] = [];
  @Input() isShowArquivosAnexados: boolean;
  @Output() abrirFecharEmitter = new EventEmitter();

  constructor(private readonly ocorrenciasService: GerenciarOcorrenciasService) { }

  public abrirFechar(): void {
    this.isShowArquivosAnexados = !this.isShowArquivosAnexados;
    this.abrirFecharEmitter.emit();
  }
}
